import React, { Component } from 'react';
import classnames from 'classnames/bind';
import { bool, string, object, arrayOf } from 'prop-types';

import ImagePlaceholder from '../common/ImgPlaceholder/ImagePlaceholder';
import CarouselPage from './CarouselPage/CarouselPage';

import styles from './CarouselBanner.css';

const cx = classnames.bind(styles);

class CarouselBanner extends Component {
  constructor(props) {
    super(props);

    this.totalPages = props.slides.length;
  }

  static propTypes = {
    autoplay: bool,
    className: string,
    slides: arrayOf(object).isRequired,
    left: bool
  }

  state = {
    activePage: 1
  }

  handleCarousel = ({ currentPage }) => this.setState({ activePage: currentPage });

  render () {
    const { activePage } = this.state;
    const { className, slides, autoplay, left } = this.props;

    const collection = [null, ...slides];
    const { imageUrl, ...pageContent } = collection[activePage];

    return (
      <section className={cx('wrapper', className, { 'left': left })}>
        <ImagePlaceholder imageUrl={imageUrl} rightSide={left} />
        <CarouselPage
          autoplay={autoplay}
          totalPages={this.totalPages}
          currentPage={activePage}
          carouselHandler={this.handleCarousel}
          leftSide={left}
          {...pageContent}
        />
        <div className={styles.pageBg} />
      </section>
    );
  }
}

export default CarouselBanner;


// WEBPACK FOOTER //
// ./src/uis/components/Banner/OthersBanner/CarouselBanner/CarouselBanner.js